module.exports = __webpack_public_path__ + "_app/img/google.6af845e4.svg";